var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 11.3077L14.9997 17.6161L8.69108 11.3076C8.15862 10.7751 7.29517 10.775 6.76262 11.3077C6.23017 11.8402 6.23017 12.7036 6.76262 13.2361L14.0355 20.5088C14.1622 20.6355 14.3125 20.7359 14.478 20.8044C14.6434 20.873 14.8207 20.9082 14.9998 20.9082C15.1789 20.9082 15.3562 20.8729 15.5217 20.8044C15.6871 20.7359 15.8375 20.6354 15.9641 20.5087L23.2366 13.236C23.7692 12.7035 23.7692 11.8401 23.2365 11.3076C22.7041 10.7751 21.8406 10.775 21.3081 11.3077Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.729 0 0 6.729 0 15C0 23.271 6.729 30 15 30C23.271 30 30 23.271 30 15C30 6.729 23.271 0 15 0ZM15 27.2727C8.23273 27.2727 2.72727 21.7672 2.72727 15C2.72727 8.23282 8.23273 2.72727 15 2.72727C21.7673 2.72727 27.2727 8.23282 27.2727 15C27.2727 21.7672 21.7672 27.2727 15 27.2727Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown);
export default __webpack_public_path__ + "static/media/icon-dropdown.77082a8bb9de3d8f10949a7aea13d913.svg";
export { ForwardRef as ReactComponent };